import axios from 'axios';
import authHeader from '../services/AuthHeader';

 import {ENV_URL} from './Globals';
const ACTIVITIES_API_URL = `${ENV_URL}/api/v1/activities`;


class ActivityService {

    getAllActivities() {
        return axios.get(`${ACTIVITIES_API_URL}`, {
            headers: authHeader()
        });
    };

 
    createActivity(data) {
        return axios.post(`${ACTIVITIES_API_URL}`,data, {
            headers: authHeader()
        });
    }

    getActivity(id) {
        return axios.get(`${ACTIVITIES_API_URL}/${id}`, {
            headers: authHeader() 
        });
    };

    getActivitiesByDate(date) {
        return axios.get(`${ACTIVITIES_API_URL}/date/${date}`, {
            headers: authHeader() 
        });
    };


    updateActivity(id,data) {
        return axios.put(`${ACTIVITIES_API_URL}/${id}`, data , {
            headers: authHeader()
        });
    };


    deleteActivity(id) {
    return axios.delete(`${ACTIVITIES_API_URL}/${id}`, {
        headers: authHeader()
    });
};

}

const activityService = new ActivityService();
export default activityService;